import onSubmitDistributor from 'utils/on-submit-distributor/onSubmitDistributor';
import { DistributorRegisterOnSubmitFunction } from '../../createDistributor.type';

const distributorUpdateOnSubmit:  DistributorRegisterOnSubmitFunction= payload => {
  return onSubmitDistributor({ method: 'put', ...payload, id: payload.distributor.id });
};

export default distributorUpdateOnSubmit;